export const GoalLabel = () => <>목표</>

export const DetailHeader = () => <>커리큘럼 자세히 보기</>

export function arrow(): string {
    return `/icons/arrow-up.svg`;
}

export {}